// RiskCategory-specific validation - Uses generic validation utility
import { createValidation } from '../../../utils/validation';

/**
 * RiskCategory-specific validation factory
 * This is a thin wrapper around the generic validation utility
 * for backwards compatibility with existing riskCategory module code
 */
export const createRiskCategoryValidation = (fields) => {
  const validation = createValidation(fields);
  
  // Return both generic and specific method names for flexibility
  return {
    schema: validation.schema,
    validateData: validation.validateData, // Generic name for configInit
    validateRiskCategoryData: validation.validateData, // Specific name for backwards compatibility
    validateField: validation.validateField
  };
};

// Default export for backwards compatibility
export default createRiskCategoryValidation;
